export default "__VITE_ASSET__5862581d__"